module.exports = __webpack_public_path__ + "static/media/logo.87bf6770.png";